// removed by extract-text-webpack-plugin
module.exports = {"index":"_4Am5IQJlRDxDebzxX2iF9","is-mobile":"_2UcCNZq2ff6M1DDuKiIY-Z"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Contacts/index.css
// module id = 284
// module chunks = 0